import { Link } from "react-router-dom";
import { Waves, ArrowRight, BookOpen, ClipboardCheck } from "lucide-react";

export default function NotFound() {
  return (
    <div className="bg-navy min-h-[80vh] hero-grain relative overflow-hidden flex items-center">
      <div className="absolute inset-0 gold-glow" />
      <div className="relative max-w-xl mx-auto px-5 py-20 text-center" data-testid="not-found-page">
        <span className="inline-flex w-14 h-14 rounded-full bg-gold items-center justify-center mb-6">
          <Waves className="w-7 h-7 text-navy" strokeWidth={2.4} />
        </span>
        <p className="font-serif text-7xl font-semibold text-gold">404</p>
        <h1 className="mt-3 font-serif text-3xl sm:text-4xl font-semibold text-cream">This page drifted off course</h1>
        <p className="mt-4 text-cream/70 leading-relaxed">
          The page you're looking for doesn't exist — but your legacy planning journey is right on track.
        </p>
        <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
          <Link to="/" data-testid="notfound-home-link" className="min-h-[52px] inline-flex items-center justify-center gap-2 rounded-full bg-gold hover:bg-gold-hover text-navy font-extrabold text-sm tracking-widest px-8 transition-colors">
            BACK TO HOME
          </Link>
          <Link to="/checkup" data-testid="notfound-checkup-link" className="min-h-[52px] inline-flex items-center justify-center gap-2 rounded-full border border-cream/30 hover:border-gold hover:text-gold text-cream font-bold text-sm tracking-widest px-8 transition-colors">
            <ClipboardCheck className="w-4 h-4" /> TAKE THE CHECKUP
          </Link>
          <Link to="/learn" data-testid="notfound-learn-link" className="min-h-[52px] inline-flex items-center justify-center gap-2 rounded-full border border-cream/30 hover:border-gold hover:text-gold text-cream font-bold text-sm tracking-widest px-8 transition-colors">
            <BookOpen className="w-4 h-4" /> LEARN <ArrowRight className="w-4 h-4 hidden" />
          </Link>
        </div>
      </div>
    </div>
  );
}
